/** Catégorie active sauf si explicitement désactivée (rétrocompatibilité). */
export const isCategoryActive = (category) => category?.is_active !== false;

export const filterActiveCategories = (categories) =>
  (categories || []).filter(isCategoryActive);

/** Options de liste dynamique ; conserve la sélection courante si inactive (édition). */
export const getCategoryOptionsForSelect = (categories, selectedCategoryId = null) => {
  const active = filterActiveCategories(categories);
  let list = active;
  if (selectedCategoryId && !active.some((c) => c.id === selectedCategoryId)) {
    const current = (categories || []).find((c) => c.id === selectedCategoryId);
    if (current) list = [...active, current];
  }
  return list.map((c) => ({ value: c.id, label: c.name }));
};
